module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAcBAMAAAB4wzlQAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURbzV7kxpcbzV7rzV7rzV7rzV7rzV7rzV7rzV7rzV7rzV7rzV7rzV7jmovIoAAAAMdFJOU2AAoFBAhuRnXAfE+PAxHh4AAABMSURBVBjTYxDPOQMDBxhqziBxco4yIMCZREEYEGA4gyKDrAeNowhUznPmiKAN9TitSJwOwRAEZ6KgJIIDAnTk5JxZAA2NGLRARA5eAMu1gc1zmOutAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/train/txt_icon.png
// module id = F6Ai
// module chunks = 38